import { render, staticRenderFns } from "./CopyCoinCof.vue?vue&type=template&id=1a8db53a&scoped=true&"
import script from "./CopyCoinCof.vue?vue&type=script&lang=js&"
export * from "./CopyCoinCof.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=1a8db53a&lang=less&scoped=true&"
import style1 from "./CopyCoinCof.vue?vue&type=style&index=1&id=1a8db53a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8db53a",
  null
  
)

export default component.exports